 export const base_url='https://admin.bahwanauto.com/'